import { radius } from '@alison/ui';
import CheckIcon from '@mui/icons-material/Check';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface SlackSetupSuccessToastProps {
  channel: string | null;
  onClose: () => void;
}

export function SlackSetupSuccessToast({
  channel,
  onClose,
}: SlackSetupSuccessToastProps): ReactNode {
  return (
    <Snackbar
      open={channel !== null}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={onClose}
    >
      <Stack
        role="status"
        direction="row"
        sx={{
          alignItems: 'center',
          gap: 2,
          px: 3,
          py: 2,
          borderRadius: `${radius.lg}px`,
          bgcolor: '#303238',
          color: 'common.white',
          boxShadow: '0 12px 32px rgba(15, 23, 43, 0.28)',
        }}
      >
        <CheckIcon sx={{ fontSize: 17, color: 'success.light' }} />
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'inherit' }}>
          Slack connected{channel ? ` · posting to #${channel}` : ''}
        </Typography>
      </Stack>
    </Snackbar>
  );
}
